<script setup>
import {ref, computed, getCurrentInstance} from 'vue'
import FormControlTypeRelationshipManyToMany from '../form-control-type/FormControlTypeRelationshipManyToMany'

// Define Component Props
const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object
})

// Retrieve Internal Component Proxy for Vuex Global Scope Access
const proxy = getCurrentInstance().proxy
const $store = proxy.$store

// Template Child References
const myChild = ref(null)

// Reactive Local State Definitions
const btnDisabled = ref(false)

// Computed Property State Tracking
const tableName = computed(() => {
    return $store.state[props.formId]?.tableName
})

const id = computed(() => {
    return $store.state[props.formId]?.id
})

const urlSegment = computed(() => {
    return props.field?.name === 'customerEmailMessageId' ? 'customer' : 'internal'
})

// Component Trigger Actions
const sendEmail = () => {
    if (!confirm('Are you sure?')) return

    btnDisabled.value = true

    $store.dispatch('request/get', {
            url: $store.state.apiEndpoint + '/api/order-email/' + id.value + '/' + urlSegment.value,
        })
        .then(() => {
            btnDisabled.value = false

            // Defensive execution execution path tracking to avoid early lifecycle exceptions
            if (myChild.value) {
                myChild.value.loadIds()
            }
        })
}
</script>

<script>
export default {
    name: "OrdersEmails"
}
</script>

<template>
    <div>
        <FormControlTypeRelationshipManyToMany ref="myChild" :current-data="currentData" :field="field"
                                               :form-id="formId"/>

        <p class="mt-2">
            <button class="btn btn-light" :disabled="btnDisabled" @click="sendEmail">
                Send email
            </button>
        </p>
    </div>
</template>